import { render, staticRenderFns } from "./tzgd.vue?vue&type=template&id=4f969d39&scoped=true"
import script from "./tzgd.vue?vue&type=script&lang=js"
export * from "./tzgd.vue?vue&type=script&lang=js"
import style0 from "./tzgd.vue?vue&type=style&index=0&id=4f969d39&prod&scoped=true&lang=scss"
import style1 from "./tzgd.vue?vue&type=style&index=1&id=4f969d39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f969d39",
  null
  
)

export default component.exports